import "./oh-call-to-action.scss";

const OHCallToAction = () => {
  return (
      <section className="OHCallToAction-container">
        <header>
          <h1>
            开启你的圣经与
            <br />
            信仰探索之旅
          </h1>
        </header>

        <div className="link-container-w-header">
          <a className="link-btn-secondary" href="https://runfortruth.com?source_topic=" target="_blank" rel="noopener noreferrer">
            点击开始
          </a>
          <div className="link-container">
            <a
              className="link-btn-primary link-txt link-1"
              href="https://runfortruth.com#qa?source_topic="
              target="_blank" rel="noopener noreferrer"
            >
              <div className="link-btn-lead-icon link-btn-lead-icon-text">
                🙋‍♀️
              </div>
              提问与解答
            </a>
            <a
              className="link-btn-primary link-txt link-2"
              href="https://runfortruth.com#pray?source_topic="
              target="_blank" rel="noopener noreferrer"
            >
              <div className="link-btn-lead-icon link-btn-lead-icon-text">
                🙏
              </div>
              祷告与树洞
            </a>
            <a
              className="link-btn-primary link-txt link-3"
              href="https://runfortruth.com#steps?source_topic="
              target="_blank" rel="noopener noreferrer"
            >
              <div className="link-btn-lead-icon link-btn-lead-icon-text">
                ⛪
              </div>
              成为基督徒
            </a>
            <a
              className="link-btn-primary link-txt link-4"
              href="https://runfortruth.com#more?source_topic="
              target="_blank" rel="noopener noreferrer"
            >
              <div className="link-btn-lead-icon link-btn-lead-icon-text">
                💬
              </div>
              更多资源…
            </a>
          </div>
        </div>
      </section>
  );
};

export default OHCallToAction;
